<div class="d-flex flex-column justify-content-center m-step-wrapper1 container wrapper-get-code-component">
  <span>
    {{otpInstructionCode}}
  </span>

  <form class="form-column" #fSendCodeOtp="ngForm" novalidate [formGroup]="otpSendCodeForm" (submit)="checkOTPCode()">
    <div class="section phone-dropdown">
      <div class="input-wrapper">
        <input type="text" value="" onchange="setAttribute('value', this.value)" class="app-input"
          aria-label="Confirmation Code" formControlName="code" #otpCode maxlength="6" NumbersOnly required>
        <label class="label">{{'otp.enter-code'|translate}}</label>
        <label class="m-error text-center text-md-right"
          *ngIf="otpSendCodeForm.controls['code'].errors && isSubmitted">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
        <!-- <label class="m-error text-center text-md-right" *ngIf="otpSendCodeForm.get('code').hasError('numbers')">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label> -->
      </div>

    </div>
    <div class="section">
      <a class="link" (click)="back()">{{"otp.request-new-code"|translate}}</a>
    </div>
    <div class="section button-section">
      <button type="submit" class="app-button"
        [ngClass]="{'button-primary': otpSendCodeForm.valid, 'button-primary-disabled': !(otpSendCodeForm.valid)}">{{"otp.confirm-btn"|translate}}</button>
    </div>
  </form>
</div>


// WEBPACK FOOTER //
// ./src/app/login/otp/confirm-code/confirm-code.component.html